import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { LocationsComponent } from "../../components/locations"

export const LocationsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <LocationsComponent />
    </DefaultPageComp>
  </>
}